{
  "manager": {
    "taxIndex": {
      "title": "Tax Rates",
      "headTitle": "Taxes"
    },
    "taxStore": {
      "displayNameLabel": "Display Name *",
      "displayNamePlaceholder": "Enter a display name for this tax rate",
      "displayNameDescription": "This is the name that will be displayed to your customers.",
      "displayNameInvalid": "This field is required.",
      "taxPercentLabel": "Tax Percentage *",
      "taxPercentInvalid": "This field is required and must be between 0-100 inclusive.",
      "taxPercentLockedDescription": "This field cannot be modified after initial creation.",
      "taxJurisdictionLabel": "Tax Jurisdiction *",
      "editHeader": "Edit Tax Rate",
      "createHeader": "Create Tax Rate",
      "entityTaxRate": "Tax rate"
    }
  }
}
